module.exports = __webpack_public_path__ + "static/media/snake.39587f96.svg";